
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Hillspghinjewadi() {



    const cardData =
    {
        keyword: '7 Hills PG Hinjewadi ',
        heading: 'Shree Swami Samarth PG: 7 Hills PG Hinjewadi',
        headingDescription: 'Shree Swami Samarth PG offers reliable and affordable accommodation options similar to the popular 7 Hills PG in Hinjewadi, providing a safe, comfortable, and homely living experience for students and IT professionals. Strategically located near Hinjewadi Phase 1, 2, and 3, our PG ensures easy access to major companies like Infosys, Wipro, and Capgemini, reducing commuting time and adding convenience to everyday life. The rooms are spacious, clean, and well-furnished with proper bedding, study/work areas, and ample storage, making them ideal for both single and shared occupancy. Residents benefit from modern amenities such as high-speed WiFi, hygienic home-cooked meals, 24x7 water supply, CCTV surveillance, and regular housekeeping. With disciplined management, budget-friendly rent plans, and a peaceful environment, Shree Swami Samarth PG is a trusted alternative for those searching for dependable and comfortable PGs like 7 Hills PG in Hinjewadi.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Affordable Double-Sharing Rooms",
    "description": "7 Hills PG offers budget-conscious double-occupancy rooms suitable for both girls and boys. With rents starting at approximately ₹7,200 per bed, it delivers great value without compromising basic comfort—perfect for students or young professionals looking for wallet-friendly yet well-maintained accommodation. The setup encourages shared living dynamics while providing a personal space to unwind after a busy day."  
  },
  {
    "title": "Both Veg and Non-Veg Meals Available",
    "description": "Residing at 7 Hills PG comes with the advantage of in-house meal options—serving both vegetarian and non-vegetarian dishes. Breakfast and dinner are provided on weekdays, while weekend meals include lunch too, blending practicality with comfort. This makes daily scheduling easier, offering a balanced dining experience without the hassle of cooking or frequent dining out."  
  },
  {
    "title": "Essential Facilities & Wi-Fi Access",
    "description": "The property includes essential amenities like a fridge, RO water cooler, automatic washing machine, and dedicated 2-wheeler parking. While AC rooms are not available, the infrastructure supports a comfortable lifestyle. Additionally, Wi-Fi access is provided, helping residents stay connected for online learning, work calls, or entertainment, even though power backup details weren’t listed."  
  },
  {
    "title": "Low Deposit & Flexible Terms",
    "description": "Financial terms are both minimal and flexible: the refundable deposit is just ₹2,000, and there’s no monthly maintenance fee. A short one-month notice period adds convenience for residents with changing needs. These transparent policies make it easier to plan budgets and adjust living arrangements without long-term commitments."  
  },
  {
    "title": "Operated Since 2019 in Safe Locale",
    "description": "7 Hills PG has been operational since 2019 and is located near Laxmi Chowk, a well-connected and established part of Hinjewadi. The residential area features good road connectivity and proximity to IT hubs, retail outlets, and essential services—offering both safety and convenience for daily commuting or errands."  
  },
  {
    "title": "Unisex Accommodation with Equal Access",
    "description": "Open to both girls and boys, 7 Hills PG maintains inclusive shared living arrangements. Shared policies ensure fairness and convenience, making it a good choice for students and working professionals seeking gender-neutral PG setups. The property doesn’t restrict on gender, offering flexibility and community-style living."  
  },
  {
    "title": "Trusted & Shared Community Feedback",
    "description": "While formal guest reviews for 7 Hills PG are limited, similar establishments in the area—like 7 Hills Pg Services Ladies & Gents—hold a respectable 4.0 rating from user feedback. Comments mention “fit to budget,” “good facilities,” and “healthy food,” suggesting that residents value the honest service delivery and friendly environment. (JustDial rating)"  
  },
  {
    "title": "Hygienic Bathroom & Household Utilities",
    "description": "All rooms come with attached bathrooms fitted with modern fixtures and Western-style toilets, meeting daily hygiene needs. Household utilities such as cleaning facilities and a kitchenette for light meals contribute to a self-reliant yet managed living situation. These conveniences support both independent living and comfort, especially for newcomers adjusting to hostel life."  
  }
],


"services": [
  {
    "name": "7 Hills PG Hinjewadi",
    "description": "Shree Swami Samarth PG proudly collaborates with 7 Hills PG Hinjewadi to offer premium and secure paying guest accommodations. Known for their excellent service quality, 7 Hills PG provides fully furnished rooms with all essential amenities, including Wi-Fi, power backup, housekeeping, and 24/7 security, ensuring a hassle-free stay close to major IT hubs."
  },
  {
    "name": "7 Hills Co-Living Hinjewadi",
    "description": "Experience modern co-living spaces with 7 Hills Co-Living in Hinjewadi, designed for young professionals and students seeking community living. Shared common areas, group activities, and ergonomic living spaces foster networking and a vibrant lifestyle while maintaining privacy and comfort."
  },
  {
    "name": "7 Hills Boys PG Hinjewadi",
    "description": "7 Hills Boys PG in Hinjewadi offers safe, clean, and affordable accommodations exclusively for male residents. With options for single and shared rooms, nutritious meal plans, and proximity to Infosys and other tech parks, it’s a preferred choice for working men looking for convenience and comfort."
  },
  {
    "name": "7 Hills Girls PG Hinjewadi",
    "description": "7 Hills Girls PG in Hinjewadi provides secure and comfortable living spaces for female professionals and students. The PG ensures round-the-clock security, CCTV surveillance, and women-friendly facilities, alongside furnished rooms and home-cooked meals to create a homely atmosphere."
  },
  {
    "name": "PG Near Infosys by 7 Hills",
    "description": "Located strategically near Infosys Hinjewadi, 7 Hills PG offers easy access to the campus, minimizing commute times for IT professionals. The PG features well-maintained rooms, ample parking, and reliable housekeeping, making daily life smooth and stress-free."
  },
  {
    "name": "Premium PG by 7 Hills Hinjewadi",
    "description": "For those seeking a higher standard of living, 7 Hills Premium PG in Hinjewadi delivers luxurious amenities such as air-conditioned rooms, premium furnishings, personalized meal options, and concierge services to elevate your stay experience."
  },
  {
    "name": "7 Hills PG Near Phase 1 & 2 Hinjewadi",
    "description": "7 Hills PG near Phase 1 and 2 Hinjewadi offers flexible accommodation plans with fully furnished rooms, Wi-Fi connectivity, and safe living environments. Whether you’re a student or a professional, these PGs are tailored to meet your specific needs close to your workplace or college."
  },
  {
    "name": "7 Hills Accommodation Hinjewadi",
    "description": "Offering a range of accommodation options, 7 Hills provides well-maintained PGs in Hinjewadi equipped with modern amenities, clean surroundings, and attentive support staff to ensure comfortable living for all residents."
  },
  {
    "name": "7 Hills PG with Food",
    "description": "Enjoy delicious and hygienic meals at 7 Hills PG Hinjewadi with their comprehensive food plans. From vegetarian to non-vegetarian options, meal plans are customized to residents’ preferences and dietary requirements, ensuring nutritious and timely meals daily."
  },
  {
    "name": "Reviews of 7 Hills PG Hinjewadi",
    "description": "7 Hills PG Hinjewadi has received excellent reviews for its cleanliness, security, staff hospitality, and convenient location. Residents appreciate the prompt maintenance and homely environment, making it one of the top-rated PGs in the area."
  }
],
"tableData": [
  ["7 Hills PG Hinjewadi", "7 Hills Co-Living Hinjewadi"],
  ["7 Hills Boys PG Hinjewadi", "7 Hills Girls PG Hinjewadi"],
  ["PG Near Infosys by 7 Hills", "Premium PG by 7 Hills Hinjewadi"],
  ["7 Hills PG Near Phase 1 & 2", "7 Hills Accommodation Hinjewadi"],
  ["7 Hills PG with Food", "Reviews of 7 Hills PG Hinjewadi"]
],




"whychoose": [
    {
        "WhyChooseheading": "Comfortable and Convenient Stay at 7 Hills PG Hinjewadi",
        "WhyChoosedescription": "7 Hills PG offers well-furnished and affordable paying guest accommodations in Hinjewadi, ideal for working professionals, interns, and students looking for a hassle-free living experience close to major IT hubs."
    },
    {
        "WhyChooseheading": "Strategically Located Near Hinjewadi IT Parks",
        "WhyChoosedescription": "Situated near Hinjewadi’s main IT zones, including Phases 1, 2, and 3, 7 Hills PG significantly reduces your daily commute, giving you more time to focus on work and personal life."
    },
    {
        "WhyChooseheading": "Fully Furnished Rooms with Essential Amenities",
        "WhyChoosedescription": "Choose from single, double, and triple-sharing rooms, all equipped with comfortable beds, wardrobes, study tables, and high-speed Wi-Fi to ensure a productive and relaxed stay."
    },
    {
        "WhyChooseheading": "Healthy and Hygienic Meals Included",
        "WhyChoosedescription": "Enjoy freshly prepared vegetarian and non-vegetarian meals served three times daily. Our kitchen maintains strict hygiene standards to provide nutritious and tasty food."
    },
    {
        "WhyChooseheading": "Safe and Secure Environment with 24/7 Surveillance",
        "WhyChoosedescription": "7 Hills PG prioritizes your safety with CCTV monitoring, biometric access control, and on-site security personnel, ensuring a secure and peaceful living environment."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Transparent Pricing",
        "WhyChoosedescription": "Our rent packages cover accommodation, meals, electricity, Wi-Fi, housekeeping, and laundry, offering a convenient all-in-one solution with no hidden costs."
    },
    {
        "WhyChooseheading": "Supportive Staff and 24/7 Assistance",
        "WhyChoosedescription": "Our dedicated management team is available round the clock to address any maintenance issues, emergencies, or general queries, ensuring a hassle-free stay."
    },
    {
        "WhyChooseheading": "Ideal for Students, Interns, and Working Professionals",
        "WhyChoosedescription": "Whether you’re starting your career, pursuing education, or completing an internship, 7 Hills PG provides a comfortable and supportive home base in the heart of Hinjewadi."
    }
]


























    }
    
const faqData = [
    {
        question: "How can I book a room at 7 Hills PG in Hinjewadi?",
        answer: "You can book by calling us at +91 9594917913. Online booking and virtual tours are also available upon request."
    },
    {
        question: "Where is 7 Hills PG located in Hinjewadi?",
        answer: "7 Hills PG is conveniently located in Hinjewadi, close to major IT parks and public transport for easy commute."
    },
    {
        question: "What types of rooms are available at 7 Hills PG?",
        answer: "We offer single, double, and triple sharing rooms, both A/C and non-A/C, fully furnished with modern amenities."
    },
    {
        question: "Is food included in the 7 Hills PG rent?",
        answer: "Yes, hygienic vegetarian meals—breakfast, lunch, and dinner—are included in the monthly rent."
    },
    {
        question: "What safety features are provided at 7 Hills PG?",
        answer: "We maintain 24/7 CCTV surveillance, biometric entry, professional staff, and restricted visitor access for your safety."
    },
    {
        question: "Are laundry and housekeeping services available at 7 Hills PG?",
        answer: "Yes, regular housekeeping and laundry services are provided to keep your living space clean and comfortable."
    },
    {
        question: "What is the monthly rent for rooms at 7 Hills PG?",
        answer: "Rent varies based on room type and amenities. Please contact us directly for the latest pricing and offers."
    },
    {
        question: "Is there a minimum stay requirement at 7 Hills PG?",
        answer: "Yes, the minimum stay is one month with flexible options for longer stays."
    },
    {
        question: "Are guests allowed at 7 Hills PG?",
        answer: "Guest entry is regulated to ensure the safety and comfort of all residents."
    },
    {
        question: "How do I contact 7 Hills PG in Hinjewadi for booking?",
        answer: "Call us at +91 9594917913 to inquire about availability, schedule visits, or confirm your booking."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Kulkarni',
        designation: 'Software Engineer, Infosys Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“7 Hills PG offers comfortable rooms with all the amenities I need. The location is perfect for daily commute.”',
    },
    {
        name: 'Ms. Shruti Patil',
        designation: 'MBA Student, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Safe and clean PG with excellent food and supportive staff. I highly recommend 7 Hills PG to fellow students.”',
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "7 Hills PG Hinjewadi",
  "image": "https://swamisamarthpg.com/assets/images/7-hills-pg-hinjewadi.jpg", // Replace with actual image URL
  "description": "Premium PG accommodation by 7 Hills in Hinjewadi near Infosys. Offering boys and girls PG, co-living spaces with food facilities and great reviews.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.92",
    "ratingCount": "2000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/7-hills-pg-hinjewadi"  // Replace with actual page URL if different
  }
};








    return (
        <div>
<Helmet>
  <title>7 Hills PG Hinjewadi | Premium Boys & Girls PG with Food</title>
  <meta 
    name="description" 
    content="Premium PG accommodation by 7 Hills in Hinjewadi near Infosys. Boys and girls PG with food and co-living facilities." 
  />
  <meta 
    name="keywords" 
    content="7 Hills PG Hinjewadi, 7 Hills Co-Living Hinjewadi, 7 Hills Boys PG Hinjewadi, 7 Hills Girls PG Hinjewadi, PG Near Infosys by 7 Hills, Premium PG by 7 Hills Hinjewadi, 7 Hills PG Near Phase 1 & 2, 7 Hills Accommodation Hinjewadi, 7 Hills PG with Food, Reviews of 7 Hills PG Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hillspghinjewadi;